<template>
  <v-btn
    v-if="params.value == '1'"
    color="success"
    small
    text
  >
    <v-icon class="mr-1">
      mdi-check-bold
    </v-icon>
  </v-btn>
</template>
